
import promise from 'es6-promise'
import 'babel-polyfill'
import Vue from 'vue'

import App from './App'
import MuseUI from './muse-ui'
import Toast from './muse-ui-plugin/muse-ui-toast'

import Message from './muse-ui-plugin/muse-ui-message'
import theme from './muse-ui/theme'
import '../static/css/common.css'
import '../static/css/iconfont.css'
import 'material-design-icons-iconfont'
import './assets/js/directives.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
import router from './routers/index'
import echarts from 'echarts'
import lottie from 'vue-lottie';
import Validate from '@/utils/validate'
import ValidateEn from '@/utils/validateEn'
import x2js from 'x2js'
import store from '@/vuex/store'
import XLSX from 'xlsx'
import axios from 'axios'
import '@/permission' // permission control

promise.polyfill()

theme.add('zenith-perception', {
  primary: '#0f58d6',
  info: '#602FED',
  success: '#18B47A',
  warning: '#FF9900',
  error: '#FA4645',
  grey: '#929DA5'
}, 'dark')
theme.use('zenith-perception')

Vue.component('lottie', lottie)

Vue.prototype.$znValidate = Validate
Vue.prototype.$enValidate = ValidateEn
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.prototype.$echarts = echarts
Vue.prototype.$x2js = new x2js()

Vue.use(XLSX)

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(MuseUI)
Vue.use(Toast);
Vue.use(ElementUI)
Vue.use(Message, {
  className: 'custom-confirm-dialog',
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App},
  template: '<app/>'

})

// 全局过滤器
Vue.filter('dateFmt', (value) => {
  console.log(value)
  if (value == null) {
    return "";
  }
  var time = new Date(parseInt(value));
  var y = time.getFullYear();
  var m = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
  var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
  var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
  var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
  var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
  return y + '-' + m + '-' + d + ' '+ h + ':' + mm + ':' + s;
})

Vue.filter('datetime', (code) => {
  if(code != null){
    Date.prototype.toLocaleString = function() {
      // 补0   例如 2018/7/10 14:7:2  补完后为 2018/07/10 14:07:02
      function addZero(num) {
        if(num<10)
          return "0" + num;
        return num;
      }
      // 按自定义拼接格式返回
      return this.getFullYear() + "-" + addZero(this.getMonth() + 1) + "-" + addZero(this.getDate()) + " " +
        addZero(this.getHours()) + ":" + addZero(this.getMinutes()) + ":" + addZero(this.getSeconds());
    };
// 根据毫秒数构建 Date 对象
    var date = new Date(code);
// 按重写的自定义格式，格式化日期
    var dateTime = date.toLocaleString();
    return dateTime
  }else {
    return null
  }
});
Vue.filter('formatDateForMS', (time) => {
  var hours, minutes, seconds;
  var totalSeconds = parseInt(time);
  seconds = parseInt(totalSeconds % 60);
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  minutes = parseInt((totalSeconds % 3600) / 60);
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  hours = parseInt(totalSeconds / 3600);
  if (hours < 10) {
    hours = "0" + hours;
  }
  return hours + ":" + minutes + ":" + seconds;
})
Vue.filter('formatDateForAMPM', (time) => {
  if (time == null) {
    return '';
  }
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  var str;
  if(h>12) {
      h -= 12;
      str = " PM";
  }else{
      str = " AM";
  }
  h = h < 10 ? "0" + h : h;
  d = d < 10 ? "0" + d : d;
  m = m < 10 ? "0" + m : m;
  mm = mm < 10 ? "0" + mm : mm;
  s = s < 10 ? "0" + s : s;
  var xy = m + "/" + d + "/" + y + " " + h + ":" + mm + ":" + s;
  xy += str;
  return xy;
})
Vue.filter('intToArray', (intValue) => {
  var retArray = [];
  for (var i = 1; i <= intValue; i ++) {
    retArray.push(i);
  }
})
Vue.filter('ConvertFileSize', (intValue) => {
  var fileSizeByte = intValue;
  var fileSizeMsg = "";
  if(fileSizeByte < 1024){
    if(fileSizeByte == null){
      fileSizeByte = 0;
    }
    fileSizeMsg = fileSizeByte+"B"
    return fileSizeMsg;
  }
  if (fileSizeByte < 1048576) fileSizeMsg = parseInt(fileSizeByte / 1024) + "KB";
  else if (fileSizeByte == 1048576) fileSizeMsg = "1MB";
  else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = parseInt((fileSizeByte / (1024 * 1024))) + "MB";
  else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = "1GB";
  else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = parseInt(fileSizeByte / (1024 * 1024 * 1024)) + "GB";
  else fileSizeMsg = "文件超过1TB";
  return fileSizeMsg;
})



// WEBPACK FOOTER //
// ./src/main.js